import { useCallback } from "react";
import useWeb3 from "../useWeb3";
import { chinaContract, chinaContract12 } from "../../utils/contractHelpers";
import { useWeb3React } from "@web3-react/core";
import Environment from "../../utils/Environment";

const usePurchaseNFTwithTomi = () => {
  const { account } = useWeb3React();
  const web3 = useWeb3();

  const contractType = Environment?.presale?.contractVersion;
  const isFirstContractVersion = contractType === "v0";

  const tokenAddress = Environment.presaleContract;

  const contract = isFirstContractVersion
    ? chinaContract(tokenAddress, web3)
    : chinaContract12(tokenAddress, web3);

  const TomiAddress = Environment.tomi;

  const purchaseNFTwithTomi = useCallback(
    async (
      postApiRes,
      currentRound,
      nftPriceArray,
      price,
      nftPriceArray1,
      balance,
      index,
      checkBox,
    ) => {
      if (!account) throw new Error("WALLET_NOT_CONNECTED");

      // Convert TOMI amount to mwei
      let amount = nftPriceArray1 / price;
      amount = parseFloat(amount).toFixed(6);
      const valueInWei = web3.utils.toWei(amount.toString(), "mwei");

      console.log("NFT TOMI purchase params:", {
        TomiAddress,
        nftPriceArray,
        valueInWei,
      });

      try {
        return new Promise(async (resolve, reject) => {
          const args = isFirstContractVersion
            ? [
                TomiAddress,
                postApiRes.price,
                postApiRes.normalizationFactorToken,
                postApiRes.code,
                currentRound,
                nftPriceArray,
                postApiRes.deadline,
                index,
                postApiRes.agentsAddresses,
                postApiRes.agentsPercentages,
                postApiRes.v,
                postApiRes.r,
                postApiRes.s,
              ]
            : [
                TomiAddress,
                postApiRes.price,
                postApiRes.normalizationFactorToken,
                postApiRes.normalizationFactorNft,
                postApiRes.code,
                currentRound,
                nftPriceArray,
                postApiRes.deadline,
                index,
                postApiRes.agentsAddresses,
                postApiRes.agentsPercentages,
                postApiRes.v,
                postApiRes.r,
                postApiRes.s,
              ];

          console.log("BUYING NFT WITH TOMI PARAMS:", args);

          let gas;

          try {
            gas = await contract.methods.purchaseNFTWithToken
              .apply(contract.methods, args)
              .estimateGas({ from: account });
          } catch (err) {
            return reject(err);
          }

          const gasLimit = Math.floor(gas * 1.2);

          contract.methods.purchaseNFTWithToken
            .apply(contract.methods, args)
            .send({ from: account, gas: gasLimit })
            .on("transactionHash", (hash) => {
              console.log("NFT TOMI tx hash:", hash);
            })
            .on("receipt", (receipt) => {
              console.log("NFT TOMI purchase confirmed:", receipt);
              resolve({
                transactionHash: receipt.transactionHash,
                receipt,
              });
            })
            .on("error", (error) => {
              console.error("NFT TOMI purchase error:", error);
              reject(error);
            });
        });
      } catch (error) {
        throw error;
      }
    },
    [account, contract, web3, isFirstContractVersion],
  );

  return { purchaseNFTwithTomi };
};

export default usePurchaseNFTwithTomi;
